import React, { useState } from 'react';
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';
import { Link } from 'react-router-dom'
import Countdown from "react-countdown";
import { Tab, Tabs, TabList, TabPanel  } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import liveAuctionData from '../assets/fake-data/data-live-auction';
import LiveAuction from '../components/layouts/LiveAuction';
import img1 from '../assets/images/box-item/card-item-10.jpg'
import img2 from '../assets/images/avatar/avt-11.jpg'
import img3 from '../assets/images/avatar/avt-1.jpg'
import img4 from '../assets/images/avatar/avt-5.jpg'
import img5 from '../assets/images/avatar/avt-7.jpg'
import img6 from '../assets/images/avatar/avt-8.jpg'
import img7 from '../assets/images/avatar/avt-2.jpg'
import imgdetail1 from '../assets/images/box-item/images-item-details2.jpg'

const ItemDetails02 = () => {
    const [dataHistory] = useState(
        [
            {
                name:"Admin",
                time: "2 hours ago",
                action: "Delivery Item"
            },
                        {
                name:"You",
                time: "4 hours ago",
                action: "Paid",
            },
            {
                name:"Admin",
                time: "6 hours ago",
                action: "Confirmed",
            },

            {
                name:"You",
                time: "8 hours ago",
                action: "Place Offer",
            }
        ]
    )
    const [dataChat] = useState(
        [
            {
                name:"Admin",
                time: "2 hours ago",
                message: "Alo ban oi"
            },
                        {
                name:"You",
                time: "4 hours ago",
                message: "Alo",
            },
            {
                name:"Admin",
                time: "6 hours ago",
                message: "Check giup minh nhe",
            },

            {
                name:"You",
                time: "8 hours ago",
                message: "OK ban",
            }
        ]
    )
    return (
        <div className='item-details'>
            <Header />
            <div className="tf-section tf-item-details style-2">
                <div className="themesflat-container">
                    <div className="row">
                        <div className="col-xl-4 col-md-12">
                            <div className="content-left">
                                <div className="media">
                                    <img src={img1} alt="Axies" />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-8 col-md-12">
                            <div className="content-right">
                                <div className="sc-item-details">
                                    <div className="meta-item">
                                        <div className="left">
                                            <h2>★ Sport Gloves | Pandora's Box</h2>
                                        </div>

                                    </div>
                                    <div className="meta-item-details">
                                        <div className="item-style-2 item-details">
                                            <ul className="list-details">
                                                <li><span>Price : </span><h6>1,000,000 VNDD</h6> </li>
                                                <li><span>Tag : </span><h6>Factory New</h6> </li>
                                                <li><span>Float : </span><h6>0.134556</h6> </li>
                                                <li><span>Phase : </span><h6>Ruby</h6> </li>
                                            </ul>
                                        </div>
                                        <div className="item-style-2">
                                            <div className="item meta-price">
                                                <span className="heading">Status</span>
                                                <div className="price">
                                                    <div className="price-box">
                                                        <h5> Confirming</h5>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="item count-down">
                                            <Countdown date={Date.now() + 500000000}>
                                                <span>You are good to go!</span>
                                            </Countdown>
                                            </div>
                                        </div>
                                    </div>
                                    <Link to="/wallet-connect" className="sc-button loadmore style bag fl-button pri-3"><span>Paid</span></Link>
                                    <div className="flat-tabs themesflat-tabs">
                                    <Tabs>
                                        <TabList>
                                        <Tab>Chat</Tab>
                                        <Tab>History</Tab>
                                        </TabList>

                                        <TabPanel>
                                            <ul className="bid-history-list">
                                                {
                                                    dataChat.map((chat, index) => (
                                                        <li>
                                                            <div className="content">
                                                                <div className="client">
                                                                    <div className="sc-author-box style-2">
                                                                        <div className="author-infor">
                                                                            <div className="name">
                                                                                <h6>{chat.name}</h6> <span> {chat.message}</span>
                                                                            </div>
                                                                            <span className="time">{chat.time}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        </TabPanel>

                                         <TabPanel>
                                            <ul className="bid-history-list">
                                                {
                                                    dataHistory.map((item, index) => (
                                                        <li key={index} item={item}>
                                                            <div className="content">
                                                                <div className="client">
                                                                    <div className="sc-author-box style-2">
                                                                        <div className="author-infor">
                                                                            <div className="name">
                                                                                <h6>{item.name}</h6> <span> {item.action}</span>
                                                                            </div>
                                                                            <span className="time">{item.time}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        </TabPanel>
                                    </Tabs>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <LiveAuction data={liveAuctionData} />
            <Footer />
        </div>
    );
}

export default ItemDetails02;
